module.exports = __webpack_public_path__ + "img/trial_flora_202410.020bc7b3.jpg";